import { NavLink } from 'react-router-dom';
import { List } from '@phosphor-icons/react';

export const MobileBottomNav = ({ items, chatUnread, t, setMobileNav }) => (
  <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 glass border-t border-slate-200/60 flex items-stretch justify-around px-1 pb-[env(safe-area-inset-bottom)]" data-testid="mobile-bottom-nav">
    {items.slice(0, 4).map(({ to, label, icon: Icon }) => (
      <NavLink key={to} to={to} end={to === '/'} data-testid={`bottomnav-${label.toLowerCase().replace(/[^a-z]+/g, '-')}`}
        className={({ isActive }) => `relative flex flex-col items-center justify-center gap-0.5 flex-1 py-2 press ${isActive ? 'text-orange-600' : 'text-slate-500'}`}>
        {({ isActive }) => (<>
          <Icon size={22} weight={isActive ? 'fill' : 'duotone'} />
          <span className="text-[10px] font-medium truncate max-w-[64px]">{t(label)}</span>
          {to === '/chat' && chatUnread?.unread > 0 && <span className="absolute top-1 right-1/4 bg-orange-500 text-white text-[8px] rounded-full px-1 font-bold">{chatUnread.unread}</span>}
        </>)}
      </NavLink>
    ))}
    <button data-testid="bottomnav-more" onClick={() => setMobileNav(true)}
      className="flex flex-col items-center justify-center gap-0.5 flex-1 py-2 text-slate-500 press">
      <List size={22} weight="duotone" />
      <span className="text-[10px] font-medium">More</span>
    </button>
  </nav>
);
